import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientNoteQKeys } from "@hooks/queries/patientNote/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  patientNoteId: string;
  patientId: string;
}

export const useDeletePatientNote = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ patientNoteId, patientId }: MutationProps) => {
      return api.delete(`notes/${patientNoteId}`);
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-patient-note-success",
      });

      queryClient.invalidateQueries(
        patientNoteQKeys.allWithFilters({ patientId: variables.patientId })
      );
    },

    onError: (res: any) => {
      console.error("[From Delete Patient Note]", res);

      handleErrors(res, "mutation");
    },
  });
};
